'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const {trackSeoLinkClick} = require('../../actions/pdpTrackingActions');
const hasContextTypes = require('../../../global/reactHelpers/hasContextTypes');


const SeoLink = React.createClass(hasContextTypes({
    propTypes: {
        link: PropTypes.object.isRequired
    },

    _handleClick() {
        this.context.executeAction(trackSeoLinkClick, { label: '' });
    },

    render() {
        const link = this.props.link;

        return (
            <li className="seo-link-wrapper colXs12 colMd4">
                <a className="seo-link" href={link.url} onClick={this._handleClick}>{link.anchorText}</a>
            </li>
        );
    }
}));

module.exports = SeoLink;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/SeoLinks/SeoLink.jsx